 
 import Vue from 'vue'
 import VueRouter from 'vue-router'
 import Router from 'vue-router'
import store from '@/store/index'
import security from './../utils/security'
import localStore from './../utils/localStore'
import JsonUtils from './../utils/json'
// 阻止重复点击报错
// const originalPush = vueRouter.prototype.push;
// vueRouter.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err);
// }

Vue.use(Router)
const router = new VueRouter({
    routes: [
        {
            path: "/",
            redirect: "/home"
        },
        {
            path: '/login',
            name: 'login',
            component: () =>
                import('@/views/login.vue')
        },
        {
            path: '/register',
            name: 'register',
            component: () =>
                import('@/views/shop/register.vue')
        },
        {
            path: '/home',
            name: 'home',
            component: () =>
                import('@/views/Home/index.vue')
        },
        {
            path: '/member/memberList',
            name: 'memberList',
            component: () =>
                import ('@/views/member/memberListPage')
        },{
            path: '/selectMemberListPage/:returnRouter',                
            name: 'selectMemberListPage',
            component: resolve => require(['@/views/member/selectMemberListPage'], resolve)
        },{
            path: '/member/memberEdit',
            name: 'member',
            component: () =>
                import ('@/views/member/memberEdit')
        },{
            path: '/member/memberEdit/:memberId',
            name: 'member',
            component: () =>
                import ('@/views/member/memberEdit')
        },{
            path: '/memberInfo',
            name: 'memberInfo',
            component: () =>
                import ('@/views/member/memberInfo')
        },{
            path: '/memberInfo/:memberId',
            name: 'memberInfoId',
            component: () =>
                import ('@/views/member/memberInfo')
        },{
            path: '/wxScanBind/:memberId',
            name: 'wxScanBind',
            component: () =>
                import ('@/views/member/wxScanBind')
        },{
            path: '/member/cardType',
            name: 'cardType',
            component: () =>
                import ('@/views/member/cardType')
        },{
            path: '/member/cardTypeEdit/:cardTypeId',
            name: 'cardTypeEdit',
            component: () =>
                import ('@/views/member/cardTypeEdit')
        },{
            path: '/consume',
            name: 'consume',
            component: () =>
                import ('@/views/member/consume')
        },{
            path: '/consume/:memberId',
            name: 'consumeMember',
            component: () =>
                import ('@/views/member/consume')
        },{
            path: '/charge',
            name: 'charge',
            component: () =>
                import ('@/views/member/charge')
        },{
            path: '/charge/:memberId', // 充值
            name: 'chargeMember',
            component: () =>
                import ('@/views/member/charge')
        },{
            path: '/tradeRecord',
            name: 'tradeRecord',
            component: () =>
                import ('@/views/member/tradeRecord')
        },{
            path: '/tradeRecord/:memberId', // 交易记录
            name: 'memberTradeRecord',
            component: () => 
                import ('@/views/member/tradeRecord')
        },{
            path: '/member/stat',
            name: 'stat',
            component: () =>
                import ('@/views/member/stat')
        },{
            path: '/shop/shop',
            name: 'shop',
            component: () =>
                import ('@/views/shop/shop')
        },{
            path: '/shop/yszc',
            name: 'yszc',
            component: () =>
                import ('@/views/shop/yszc')
        },{
            path: '/shop/invite',
            name: 'lease',
            component: () =>
                import ('@/views/shop/invite')
        },{
            path: '/shop/lease',
            name: 'lease',
            component: () =>
                import ('@/views/shop/lease')
        },{
            path: '/shop/payWay',
            name: 'lease',
            component: () =>
                import ('@/views/shop/payWay')
        },
        {
            path: '/shop/tenantEdit',
            name: 'tenantEdit',
            component: () =>
                import ('@/views/shop/tenantEdit')
        },
        {
            path: '/shop/stat',
            name: 'stat',
            component: () =>
                import ('@/views/shop/stat')
        },
        
        {
            path: '*',
            redirect: '/home'
        }
    ]
})

// 路由权限控制
router.beforeEach((to, from, next) => {
    let user = store.state.mineStore.uid
    if (!user) {
      let tmp = localStore.getItem('mobUser', null)
      user = tmp === null ? null : JsonUtils.stringToJson(tmp)
      store.commit('save', user)
    }
    if (to.path === '/register' || to.path.includes('/feedback') || to.path === '/shop/payWay' || to.path === '/memberRegister' ||
     to.path === '/personalData' || to.path.includes('memberCenter') || to.path.includes('/memberBind') || to.path.includes('/applyCard') || 
     to.path.includes('casherSelf') || to.path.includes('casherSelfResult') || to.path.includes('tradeRecordSelf') || to.path.includes('forgetPassword') ||
     to.path.includes('/shop/yszc')) {
      next()
      return
    }
    if (security.chkLogin(user, to.path)) {
      next()
    } else {
      next('/login')
    }
  })
export default router